import React, { useState, useEffect } from "react";
import {
  Table,
  Splitter,
  Pagination,
  Spin,
  Tag,
  Switch,
  Form,
  Badge,
  Button,
  // Dropdown,
} from "antd";
import {
  CourseTopLevel,
  CourseTopLevelCA,
  // SecondaryNavTraineryLearnCA,
  // SecondaryNavTraineryLearn,
} from "../../../components/AdminComponents/MenuItems";
// import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import {
  capitalizeWords,
  ModuleColor,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { useSelector } from "react-redux";
import axiosInstance from "../../../api/Axios";
import EditableImage from "../../../components/icons/EditIcon";

import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import CourseFiltersSplitter from "./CourseFiltersSplitter";
import { useLocation, useNavigate } from "react-router-dom";
import ListingColumnModal from "./ListingColumnModal";
import {
  AppstoreOutlined,
  BarsOutlined,
  CheckOutlined,
  // CloseOutlined,
  ControlTwoTone,
  EyeTwoTone,
  ThunderboltOutlined,
  // DownOutlined,
} from "@ant-design/icons";
import ScrollableCourseCards from "../../../components/legacyComp/tetsing/ScrollableCourseCards";
import BulkActionsModal from "../../../components/AdminComponents/Modals/BulkActionsModal";
import useCommonListing from "../../../components/AdminComponents/customHooks/useCommonListing";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { GetFormattedDateTime } from "../../../components/utils/DateTimeUtils";
import { accessImpersontate } from "../../../config";
// import { env } from "../../../config";

const CourseListingCA = () => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const [showFilter, setShowFilter] = useState(true);
  const history = useNavigate();

  // Filter options and checked keys
  const [categorySearch, setCategorySearch] = useState("");
  const [filterOptions, setFilterOptions] = useState({
    classifications: [],
    categories: [],
    languages: [],
    modes: [],
    tags: [],
    producers: [],
  });
  const [checkedKeys, setCheckedKeys] = useState([]);
  const { classifications, categories, languages, modes, tags, producers } =
    filterOptions;
  const updateFilterOption = (key, value) => {
    setFilterOptions((prev) => ({ ...prev, [key]: value }));
  };

  // Load filter options
  const userInfo = useSelector((state) => state.user);
  // Original code - commented out to allow access in production when impersonating
  // const ImpersonateAccess = !accessImpersontate(
  //   userInfo?.data?.impersonate_acc
  // );
  // Always allow access for Courses section
  const ImpersonateAccess = true;
  useEffect(() => {
    const LoadFilters = async () => {
      try {
        const res = await axiosInstance.get(
          `/filter/?organization=${userInfo?.data?.organization?.id}`
        );
        updateFilterOption("classifications", res?.data?.classifications);
        updateFilterOption("categories", res?.data?.categories);
        updateFilterOption("languages", res?.data?.languages);
        updateFilterOption("modes", res?.data?.modes);
        updateFilterOption("tags", res?.data?.tags);
        updateFilterOption("producers", res?.data?.producers);
      } catch (err) {
        console.log(err);
      }
    };
    LoadFilters();
  }, [userInfo?.data?.organization?.id]);
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  console.log(accessImpersontate(userInfo?.data?.impersonate_acc));
  const {
    data,
    itemsLength,
    loading,
    filterData,
    setFilterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    handleSwitchChange,
    handleClearAll,
    setFilterUrl,
  } = useCommonListing({
    userInfo,
    passSize: 15,
    passPage: 1,
    passURL: `/courselist/?organization=${userInfo?.data?.organization?.id}`,
    persist: true, // ✅ enable persistence
    listId: "courseList", // ✅ unique key for this listing
    loadAgain: loadAgain,
  });

  const {
    pageSize,
    currentPage,
    active,
    filter_url,
    sort_column,
    sort_order,
    search,
  } = filterData;

  useEffect(() => {
    console.log("🔍 Current filterData for" || "local:", filterData);
  }, [filterData]);

  const renderStatus = (text, record) => {
    if (record.client_owned) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
    // else {
    //   return text;
    // }
  };
  const getDefaultSortOrder = (column) => {
    if (sort_column === column) {
      return sort_order === "asc" ? "ascend" : "descend";
    }
    return null;
  };
  // eslint-disable-next-line no-unused-vars
  const [allColumns, setAllColumns] = useState([
    {
      title: "Course ID",
      dataIndex: "course_id",
      key: "course_id",
      fixed: "left",
      width: 140,
    },

    {
      title: "Course Title",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 235,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("name"),
    },
    { title: "Category", dataIndex: "category", key: "category", width: 160 },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 200,
    },
    ...(!isCAAdmin
      ? [
          {
            title: "Producer",
            dataIndex: "producer_name",
            key: "producer_name",
            ellipsis: true,
            width: 150,
          },
        ]
      : []),
    {
      title: "Course Mode",
      dataIndex: "mode",
      key: "mode",
      width: 120,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("mode"),
    },
    {
      title: "Language",
      dataIndex: "language",
      key: "language",
      width: 120,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("language"),
    },
    {
      title: capitalizeWords("Content"),
      dataIndex: "coursedetails_count",
      key: "coursedetails_count",
      width: 80,
      align: "center",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          {text && text !== 0 ? (
            <Tag
              color="blue"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                fontWeight: "600",
                padding: 0,
              }}
            >
              {text}
            </Tag>
          ) : null}
        </div>
      ),
    },
    ...(isCAAdmin
      ? [
          {
            title: capitalizeWords("Users"),
            dataIndex: "user_count",
            key: "user_count",
            width: 80,
            editable: true,
            align: "center",
            sorter: true,
            sortDirections: ["ascend", "descend"],
            defaultSortOrder: getDefaultSortOrder("user_count"),
            render: (text) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                {text && text !== 0 ? (
                  <Tag
                    color="blue"
                    style={{
                      fontSize: "1.15rem",
                      width: "2.5rem",
                      height: "2.5rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      fontWeight: "600",
                      padding: 0,
                    }}
                  >
                    {text}
                  </Tag>
                ) : null}
              </div>
            ),
          },
        ]
      : []),
    // {
    //   title: "Producer SKU",
    //   dataIndex: "producer_id",
    //   key: "producer_id",
    //   ellipsis: true,
    //   width: 150,
    // },

    ...(isCAAdmin
      ? [
          {
            title: "Bundles",
            dataIndex: "bundle_count",
            key: "bundle_count",
            width: 80,
            editable: true,
            align: "center",
            sorter: true,
            sortDirections: ["ascend", "descend"],
            defaultSortOrder: getDefaultSortOrder("bundle_count"),
            render: (text) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                {text && text !== 0 ? (
                  <Tag
                    color="blue"
                    style={{
                      fontSize: "1.15rem",
                      width: "2.5rem",
                      height: "2.5rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      fontWeight: "600",
                      padding: 0,
                    }}
                  >
                    {text}
                  </Tag>
                ) : null}
              </div>
            ),
          },
        ]
      : []),
    ...(!isCAAdmin
      ? [
          {
            title: "Clients",
            dataIndex: "client_count",
            key: "client_count",
            width: 80,
            editable: true,
            align: "center",
            sorter: true,
            sortDirections: ["ascend", "descend"],
            defaultSortOrder: getDefaultSortOrder("client_count"),
            render: (text) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                {text && text !== 0 ? (
                  <Tag
                    color="blue"
                    style={{
                      fontSize: "1.15rem",
                      width: "2.5rem",
                      height: "2.5rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      fontWeight: "600",
                      padding: 0,
                    }}
                  >
                    {text}
                  </Tag>
                ) : null}
              </div>
            ),
          },
        ]
      : []),

    {
      title: "Version",
      dataIndex: "version",
      key: "version",
      width: 100,
      align: "center",
    },
    {
      title: "Source Module",
      dataIndex: "source_app",
      key: "source_app",
      align: "center",
      width: 120,
      render: (applications) => (
        <span>
          <Tag
            color={ModuleColor(applications)}
            title={applications}
            style={{ margin: "3px" }}
          >
            <span style={{ color: "black", fontWeight: "500" }}>
              {applications}
            </span>
          </Tag>
        </span>
      ),
    },
    {
      title: isCAAdmin ? "Content Owned" : "Client Owned",
      dataIndex: "client_owned",
      key: "client_owned",
      render: renderStatus,
      align: "center",
      width: 120,
    },

    {
      title: "Created",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("created_at"),
      render: GetFormattedDateTime,
    },
    {
      title: capitalizeWords("actions"),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      width: 120,
      fixed: "right",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {!isCAAdmin && record?.coursedetails_count > 0 && (
            <EyeTwoTone
              onClick={(e) => {
                e.stopPropagation(); // prevent triggering row click
                handleRowClickPreview(record?.id);
              }}
              style={{
                cursor: "pointer",
                fontSize: "1.9rem",
                marginRight: "0.9rem",
              }}
            />
          )}
          <EditableImage handleRowClick={handleRowClick} recordId={record.id} />
        </div>
      ),
    },
  ]);
  const [visibleColumns, setVisibleColumns] = useState(
    allColumns
      .map((col) => col.key)
      .filter((key) => key !== "description" && key !== "source_app") // hide these by default
  );
  const [hasChanges, setHasChanges] = useState(false);
  useEffect(() => {
    const defaultKeys = allColumns
      .map((col) => col.key)
      .filter((key) => key !== "description" && key !== "source_app");
    const isSame =
      visibleColumns.length === defaultKeys.length &&
      visibleColumns.every((key, index) => key === defaultKeys[index]);
    setHasChanges(!isSame);
  }, [visibleColumns, allColumns]);
  const filteredColumns = visibleColumns
    .map((key) => allColumns.find((col) => col.key === key))
    .filter(Boolean);
  const resetColumns = () => {
    setVisibleColumns(
      allColumns
        .map((col) => col.key)
        .filter((key) => key !== "description" && key !== "source_app")
    );
  };

  // Table row click
  const handleRowClick = (record) => {
    history(
      isCAAdmin
        ? `/ca-admin/trainery-learn/courses/edit/${record}`
        : `/trainery-learn/courses/edit/${record}`
    );
  };

  // Table row click
  const handleRowClickPreview = (record) => {
    history(
      isCAAdmin
        ? `/ca-admin/trainery-learn/courses/preview/${record}`
        : `/trainery-learn/courses/preview/${record}`
    );
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const rowSelection = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys); // store only keys
    },
  };

  // Column modal logic
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setVisibleColumns((prev) => {
      if (checked) {
        return [...prev, value];
      } else {
        return prev.filter((column) => column !== value);
      }
    });
  };
  const handleColumnSubmit = (newColumns) => {
    const reordered = newColumns.filter((col) => col !== "actions");
    if (newColumns.includes("actions")) {
      reordered.push("actions");
    }
    setVisibleColumns(reordered);
  };
  const columnOptions = allColumns.map((col) => ({
    label: col.title,
    value: col.key,
  }));

  // Filter logic for filter splitter
  const [form] = Form.useForm();
  const handleDecodedFormValues = (allValues) => {
    console.log(allValues);
    const {
      source_app = [],
      language = [],
      mode = [],
      categories = [],
      tag = [],
      duration = null,
      producer = [],
    } = allValues;
    const categoryKeys = Array.isArray(categories) ? categories : [];
    const grouped = {
      category: [],
      second_category: [],
      third_category: [],
    };
    categoryKeys.forEach((item) => {
      const [prefix, id] = item.split("-");
      const numericId = parseInt(id);
      if (!isNaN(numericId)) {
        if (prefix === "cat") grouped.category.push(numericId);
        else if (prefix === "sub") grouped.second_category.push(numericId);
        else if (prefix === "third") grouped.third_category.push(numericId);
      }
    });
    const params = new URLSearchParams();
    if (source_app.length) params.append("source_app", source_app.join(","));
    if (language.length) params.append("language", language.join(","));
    if (mode.length) params.append("mode", mode.join(","));
    if (tag.length) params.append("tags", tag.join(","));
    if (producer.length) params.append("producer", producer.join(","));
    if (duration && Array.isArray(duration) && duration.length === 2) {
      const [start, end] = duration;
      params.append("start_time", start);
      params.append("end_time", end);
    }
    Object.entries(grouped).forEach(([key, values]) => {
      if (values.length > 0) {
        params.append(key, values.join(","));
      }
    });
    const generatedFilterUrl = params.toString();
    setFilterUrl(generatedFilterUrl);
  };
  const handleCheck = (checkedKeysValue) => {
    const finalKeys = Array.isArray(checkedKeysValue)
      ? checkedKeysValue
      : checkedKeysValue.checked;
    setCheckedKeys(finalKeys);
    form.setFieldsValue({
      categories: finalKeys,
    });
    const allValues = form.getFieldsValue();
    handleDecodedFormValues(allValues);
  };

  const handleSortChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setFilterData({
        ...filterData,
        sort_column: sorter.field,
        sort_order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setFilterData({
        ...filterData,
        sort_column: "",
        sort_order: "",
      });
    }
  };

  // View and modal state
  const [view, setView] = useState("table");
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  // const handleMenuClick = ({ key }) => {
  //   setView(key);
  // };

  // const menu = [
  //   {
  //     key: "grid",
  //     icon: <AppstoreOutlined style={{ color: "#595959" }} />,
  //     label: "Grid View",
  //   },
  //   {
  //     key: "table",
  //     icon: <BarsOutlined />,
  //     label: "Table View",
  //   },
  // ];
  const handleClearWithForm = () => {
    form.resetFields();
    handleClearAll();
  };
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      {/* <SecondaryNav
        menuItems={
          isCAAdmin ? SecondaryNavTraineryLearnCA : SecondaryNavTraineryLearn
        }
      /> */}
      <CommonTopDetails
        title={active ? "Courses Summary" : "Inactive Courses"}
        titleSuffix={`${itemsLength || 0} course(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        searchValue={search}
        // marginPass="15px"
        showAddButton={ImpersonateAccess}
        filterAction={true}
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: isCAAdmin
            ? "/ca-admin/trainery-learn/courses/add"
            : "/trainery-learn/courses/add",
        }}
        sorting={true}
        filterUrl={filter_url}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: () => setShowFilter((prev) => !prev),
        }}
        resetButtonProps={{
          modalProps: handleClearWithForm,
        }}
        customContent={
          <>
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              disabled={loading}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
            {ImpersonateAccess && (
              <Button
                icon={
                  <ThunderboltOutlined style={{ fontSize: 18, opacity: 0.7 }} />
                }
                style={{
                  background:
                    selectedRowKeys.length > 0
                      ? "linear-gradient(90deg, #4daaff 0%, #1a75ff 100%)"
                      : "linear-gradient(90deg, #f8fafc 0%, #e0eafc 100%)",
                  // border: "none",
                  color: selectedRowKeys.length > 0 ? "white" : "#222", // black text
                  fontWeight: 500,
                  letterSpacing: 0.3,
                  boxShadow: "0 2px 8px rgba(24,144,255,0.08)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  transition: "background 0.3s, color 0.3s",
                }}
                onClick={() => setIsBulkModalOpen(true)}
              >
                Bulk Actions
              </Button>
            )}

            {view !== "grid" && (
              <Badge dot={hasChanges}>
                <ControlTwoTone
                  onClick={() => setIsModalOpen(true)}
                  style={{ fontSize: "29.5px" }}
                />
              </Badge>
            )}
            {/* <Dropdown
              menu={{ items: menu, onClick: handleMenuClick }}
              placement="bottomLeft"
              arrow
            > */}
            <div
              style={{
                cursor: "pointer",
                padding: "4.5px 8px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#E6F7FF",
                borderRadius: "8px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "background-color 0.3s",
                marginBottom: "2.5px",
              }}
              onClick={() => setView(view === "grid" ? "table" : "grid")}
            >
              {view === "grid" ? (
                <AppstoreOutlined
                  style={{ fontSize: "22.5px", color: "#595959" }}
                />
              ) : (
                <BarsOutlined style={{ fontSize: "22.5px" }} />
              )}
              {/* <DownOutlined
                  style={{ fontSize: "12.55px", marginLeft: "7.5px" }}
                /> */}
            </div>
            {/* </Dropdown> */}
          </>
        }
      />
      <Splitter
        style={{
          height: `${remainingViewportHeight(14)}px`,
          transition: "all 1s ease",
        }}
      >
        {showFilter && (
          <Splitter.Panel defaultSize="17.5%" min="15%" max="40%">
            <CourseFiltersSplitter
              form={form}
              handleDecodedFormValues={handleDecodedFormValues}
              setShowFilter={setShowFilter}
              handleClearAll={handleClearAll}
              classifications={classifications}
              languages={languages}
              categories={categories}
              modes={modes}
              tags={tags}
              producers={producers}
              categorySearch={categorySearch}
              setCategorySearch={setCategorySearch}
              checkedKeys={checkedKeys}
              handleCheck={handleCheck}
              filter_url={filter_url}
              origin={isCAAdmin ? "CLIENT_ADMIN" : "TN_ADMIN"}
            />
          </Splitter.Panel>
        )}
        <Splitter.Panel
          className="table-wrapper"
          style={{ overflowX: "auto", overflowY: "auto" }}
        >
          <Spin spinning={loading}>
            {view === "grid" ? (
              <div
                style={{
                  maxHeight: `${remainingViewportHeight(19)}px`,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <ScrollableCourseCards
                  courses={data}
                  handleRowClick={handleRowClick}
                />
              </div>
            ) : (
              <div
                className="table-wrapper"
                style={{ overflowX: "auto", overflowY: "auto" }}
              >
                <Table
                  columns={filteredColumns}
                  dataSource={data}
                  size="small"
                  bordered
                  rowKey="id"
                  className="table-container"
                  scroll={{
                    x: 1000,
                    y: `${remainingViewportHeight(23)}px`,
                  }}
                  rowSelection={ImpersonateAccess && rowSelection}
                  onRow={(record) => ({
                    onClick: (event) => {
                      if (
                        event.target.closest(
                          ".ant-table-cell[data-index='actions']"
                        )
                      ) {
                        return;
                      }

                      handleRowClick(record.id);
                    },
                  })}
                  style={{ marginInline: "1rem" }}
                  pagination={false}
                  onChange={handleSortChange}
                />
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
                onChange={onPageChange}
                pageSizeOptions={["10", "15", "30", "50", "100"]}
                showQuickJumper
                current={currentPage}
                defaultPageSize={pageSize}
                total={itemsLength}
              />
            </div>

            <ListingColumnModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              columnOptions={columnOptions}
              visibleColumns={visibleColumns}
              handleCheckboxChange={handleCheckboxChange}
              onSubmit={handleColumnSubmit}
              resetColumns={resetColumns}
            />
          </Spin>
        </Splitter.Panel>
      </Splitter>
      <BulkActionsModal
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        rowSelection={rowSelection}
        initialSelectedRowKeys={selectedRowKeys}
        initialCurrentPage={currentPage}
        initialPageSize={pageSize}
        initialUrl={filter_url}
        isCAAdmin={isCAAdmin}
        loadAgain={LoadAPI}
      />
    </WrapperComponent>
  );
};

export default CourseListingCA;
